<article>
    <div class="path">
        <div class="text">알림 > </div>
        <div>작성하기</div>
    </div>

    <form action="#" class="content-box" (ngSubmit)="submit()">
        <div class="btn-container">
            <button type="button" class="btn back" (click)="rollBack()"><img src="/assets/images/btn-previous.png" alt="버튼"></button>
            <div>
                <button type="button" class="btn preview" (click)="activePreview()">미리보기</button>
                <button type="submit" class="btn submit">작성하기</button>
            </div>
        </div>

        <div class="box">
            제목<br>
            <textarea name="title" class="title" cols="75" rows="1" wrap="physical" (change)="handleChange($event)"></textarea>
        </div>
        <div class="box">
            내용<br>
            <div id="ckeditor"><ckeditor [editor]="Editor" name="content" class="content" cols="100" rows="10" wrap="physical" (change)="onChange($event)"> </ckeditor></div>
        </div>
        <div class="box">
            첨부파일<br>
            <input type="file" name="file" class="file" cols="100" rows="10" wrap="physical" (change)="handleChange($event)">
        </div>
    </form>
    <app-admin-notice-preview *ngIf = "previewFlag" [notice]="notice" (previewToggle) ="unactivePreview($event)"></app-admin-notice-preview>
 
</article>

<!-- 
<script> 
        let oEditors = [];
   
        nhn.husky.EZCreator.createInIFrame({ 
            oAppRef: editor, 
            elPlaceHolder: 'content', 
            sSkinURI: '/plugin/smarteditor2/SmartEditor2Skin.html', 
            fCreator: 'createSEditor2' 
            }); 
   
</script>

 -->
